import React from 'react';

import cl from './Commercial.module.css'

import woomenImg from '../../../assets/images/woomenImg.png'
import processImg from '../../../assets/images/process.png'
import laptopHandsImg from '../../../assets/images/laptopHands.png'


import commercialImg1 from '../../../assets/images/specialistNiche.svg'
import commercialImg2 from '../../../assets/images/internationalBank.svg'

import dollarImg from '../../../assets/images/dollar.svg'
import pcImg from '../../../assets/images/pc.svg'
import doarsImg from '../../../assets/images/doars.svg'
import whiteWalletImg from '../../../assets/images/whiteWallet.svg'
import arrowsImg from '../../../assets/images/arrows.svg'
import whiteSharpImg from '../../../assets/images/whiteSharp.svg'
import whiteFieldImg from '../../../assets/images/whiteField.svg'
import whiteGuardImg from '../../../assets/images/whiteGuard.svg'
import whiteArrowImg from '../../../assets/images/whiteArrow.svg'
import whiteBarImg from '../../../assets/images/whiteBar.svg'
import whiteReverseImg from '../../../assets/images/whiteReverseArrow.svg'
import whiteFile from '../../../assets/images/whiteFile.svg'
import whiteCard from '../../../assets/images/whiteCard.svg'
import logo from '../../../assets/images/logo_black.svg'






import peopleImg from '../../../assets/images/business.png'
import { NavLink } from 'react-router-dom';




const Commercial = () => {
    return (
        <div className={cl.commercial_main_wrapper}>
            <div className={cl.main_commercial_container}>
                <h2 className={cl.commercial_title}>
                    Fortres BanCorp
                </h2>
                <div className={cl.commercial_description_wrapper}>
                    <p className={cl.commercial_description}>
                        International Private Bankers, on call nearly 24/7 via our global digital platform.
                    </p>
                </div>
                <div className={cl.commercial_items_row}>
                    <div className={cl.commercial_item}>
                        <div className={cl.img_wrapper}>
                            <img src={woomenImg} alt="" />
                        </div>
                    </div>
                        <div className={cl.commercial_item_content}>
                            <div className={cl.img_item_wrapper}>
                                <img src={commercialImg1} alt="" />
                            </div>
                            <h3 className={cl.commercial_item_title}>
                                Specialists in Niche & Emerging Markets
                            </h3>
                            <div className="commercial_descr_wrapper">
                                <p className={cl.commercial_descr}>
                                    Protect and grow wealth with bespoke strategies and secure, technology-first platforms that execute globally—efficiently and transparently.
                                </p>
                            </div>
                        </div>
                        
                        <div className={cl.commercial_item_content_white}>
                            <div className={cl.img_item_wrapper}>
                                <img src={commercialImg2} alt="" />
                            </div>
                            <h3 className={cl.commercial_item_title_white}>
                                International Commercial Banking for global companies
                            </h3>
                            <div className="commercial_descr_wrapper">
                                <p className={cl.commercial_descr_white}>
                                    We manage transactions and cross-border operations, with expert guidance on complex payments and trade finance—backed by a global network, market insights, and risk management.
                                </p>
                            </div>
                        </div>  
                        <div className={cl.commercial_item}>
                        <div className={cl.img_wrapper}>
                            <img src={processImg} alt="#" />
                        </div>
                    </div>
                </div>
                
            </div>
            <div className={cl.commercial_banking_background}>
                   <div className={cl.banking_container}>
                     <div className={cl.left_banking}>
                            <h2 className={cl.banking_title}>
                                Commercial Banking for Complex Structures
                            </h2>
                            <div className={cl.banking_descr_wrapper}>
                                <p className={cl.banking_descr}>
                                    Ideal for multi-jurisdictional businesses underserved by big banks, with solutions rigorously compliant with regulations.
                                </p>
                            </div>
                            <NavLink to='/sign-up' style={{display: 'block', maxWidth: '211px'}}>
                                <div className={cl.banking_btn}>
                                    Open Account
                                </div>
                            </NavLink>
                        </div>
                        <div className="right_banking">
                            <div className={cl.banking_img_wrapper}>
                                <img src={peopleImg} alt="" />
                            </div>
                        </div>
                   </div>
            </div>
            <div className={cl.corporate_background}>
                <div className={cl.corporate_cotainer}>
                    <h2 className={cl.corparate_title}>
                        Corporate Multi-Currency Account (MCA)
                    </h2>
                    <div className={cl.corparate_descr_wrapper}>
                        <p className={cl.corparate_descr}>
                            The MCA is our flagship product for international companies, offering ultimate   convenience:
                        </p>
                    </div>
                    <div className={cl.corparate_items_row}>
                        <div className={cl.corparate_item}>
                            <div className={cl.img_item}>
                                <img src={dollarImg} alt="" />
                            </div>
                            <div className="item_descr_wrapper">
                                <p className={cl.item_descr}>
                                    Conduct transactions in most major world currencies
                                </p>
                            </div>
                        </div>
                         <div className={cl.corparate_item}>
                            <div className={cl.img_item}>
                                <img src={arrowsImg} alt="" />
                            </div>
                            <div className="item_descr_wrapper">
                                <p className={cl.item_descr}>
                                    Consolidate and manage foreign receivables and payments efficiently
                                </p>
                            </div>
                        </div>
                         <div className={cl.corparate_item}>
                            <div className={cl.img_item}>
                                <img src={doarsImg} alt="" />
                            </div>
                            <div className="item_descr_wrapper">
                                <p className={cl.item_descr}>
                                   Send and receive wire payments
                                </p>
                            </div>
                        </div>
                         <div className={cl.corparate_item}>
                            <div className={cl.img_item}>
                                <img src={pcImg} alt="" />
                            </div>
                            <div className="item_descr_wrapper">
                                <p className={cl.item_descr}>
                                    View balances and activities for all currency accounts online
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={cl.external_container}>
                <div className={cl.left_external}>
                    <h2 className={cl.external_title}>
                        External Asset Managers Desk
                    </h2>
                    <div className={cl.external_description_wrapper}>
                        <p className={cl.external_description}>
                            We partner with financial professionals and fiduciaries to deliver core Commercial Banking services to non-resident companies, trusts, and PCCs via a secure digital channel.
                        </p>
                    </div>
                    <div className={cl.external_items_row}>
                        <div className={cl.external_item}>
                            <div className={cl.external_img}>
                                <img src={whiteWalletImg} alt="" />
                            </div>
                            <p className={cl.external_item_descr}>
                                Multi-currency deposit accounts<br/>
                                (major, exotic, and cryptocurrencies)
                            </p>
                        </div>
                        <div className={cl.external_item}>
                            <div className={cl.external_img}>
                                <img src={whiteSharpImg} alt="" />
                            </div>
                            <p className={cl.external_item_descr}>
                                Professional management of payment transactions
                            </p>
                        </div>
                        <div className={cl.external_item}>
                            <div className={cl.external_img}>
                                <img src={whiteFieldImg} alt="" />
                            </div>
                            <p className={cl.external_item_descr}>
                                Segregated sub-accounts for projects or client funds
                            </p>
                        </div>
                        <div className={cl.external_item}>
                            <div className={cl.external_img}>
                                <img src={whiteGuardImg} alt="" />
                            </div>
                            <p className={cl.external_item_descr}>
                                Custody of digital assets and execution services
                            </p>
                        </div>
                        <div className={cl.external_item}>
                            <div className={cl.external_img}>
                                <img src={whiteArrowImg} alt="" />
                            </div>
                            <p className={cl.external_item_descr}>
                                Trading and brokerage
                            </p>
                        </div>
                        <div className={cl.external_item}>
                            <div className={cl.external_img}>
                                <img src={whiteBarImg} alt="" />
                            </div>
                            <p className={cl.external_item_descr}>
                                Bespoke investment solutions
                            </p>
                        </div>
                        <div className={cl.external_item}>
                            <div className={cl.external_img}>
                                <img src={whiteReverseImg} alt="" />
                            </div>
                            <p className={cl.external_item_descr}>
                                Foreign Exchange: spot, forward, and swap
                            </p>
                        </div>
                        <div className={cl.external_item}>
                            <div className={cl.external_img}>
                                <img src={whiteFile} alt="" />
                            </div>
                            <p className={cl.external_item_descr}>
                                OTC and derivatives instruments
                            </p>
                        </div>
                        <div className={cl.external_item}>
                            <div className={cl.external_img}>
                                <img src={whiteCard} alt="" />
                            </div>
                            <p className={cl.external_item_descr}>
                                Payments, transfers, and credit cards
                            </p>
                        </div>
                    </div>
                </div>
                <div className={cl.right_external}>
                    <img src={laptopHandsImg} alt="" />
                </div>
            </div>
            <div className={cl.dedicated_container}>
                <h2 className={cl.dedicated_title}>
                    A dedicated private banker for every client, your single point of contact
                </h2>
                <h2 className={cl.dedicated_sub_title}>
                    <span className={cl.dedicated_important_text}>
                        Open online or book with our
                    </span>
                    International Commercial Banking
                    <span className={cl.dedicated_important_text}>
                        team today
                    </span>
                </h2>
                <div className={cl.dedicated_sign_up_block}>
                    <div className={cl.dedicated_img_wrapper}>
                        <img src={logo} alt="" />
                    </div>
                    <NavLink to='/sign-up'>
                        <div className={cl.open_account_button}>
                            Open Account
                        </div>
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default Commercial;